import { Phone, ShoppingBag, ChevronDown } from "lucide-react";
import { TAVERN, HERO_IMAGE } from "../../data/tavern";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative flex min-h-[92vh] items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div
        aria-hidden="true"
        className="hero-bg absolute inset-0"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      />
      <div aria-hidden="true" className="hero-overlay absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 mx-auto w-full max-w-5xl px-5 py-24 text-center text-white md:px-8">
        <p
          data-testid="hero-eyebrow"
          className="fade-up mb-6 inline-flex items-center gap-3 text-xs uppercase tracking-[0.32em] text-[#F4C96B] md:text-sm"
          style={{ animationDelay: "0.05s" }}
        >
          <span className="h-px w-8 bg-[#F4C96B]/60" />
          ΠΑΡΑΔΟΣΙΑΚΗ ΤΑΒΕΡΝΑ
          <span className="h-px w-8 bg-[#F4C96B]/60" />
        </p>

        <h1
          data-testid="hero-title"
          className="fade-up font-display text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-7xl"
          style={{ animationDelay: "0.15s" }}
        >
          {TAVERN.name}:
          <br />
          <span className="italic font-bold text-[#F4C96B]">
            {TAVERN.tagline}
          </span>
        </h1>

        <p
          data-testid="hero-subtitle"
          className="fade-up mx-auto mt-7 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg"
          style={{ animationDelay: "0.25s" }}
        >
          Το Πρώτο Κατσίκι αποτελεί σημείο αναφοράς για την παραδοσιακή
          γαστρονομία της Καβάλας, προσφέροντας ποιοτικό φαγητό, αυθεντικές
          γεύσεις και μια ζεστή οικογενειακή ατμόσφαιρα.
        </p>

        {/* Primary CTAs */}
        <div
          data-testid="hero-cta-row"
          className="fade-up mt-10 flex flex-col items-stretch justify-center gap-4 sm:flex-row sm:items-center"
          style={{ animationDelay: "0.35s" }}
        >
          <a
            href={TAVERN.efoodUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-efood-btn"
            className="cta-pulse-red group inline-flex items-center justify-center gap-3 rounded-full bg-[color:var(--pk-red)] px-7 py-4 text-sm font-bold uppercase tracking-wide text-white transition-all hover:-translate-y-1 hover:bg-[color:var(--pk-red-dark)] sm:text-base"
          >
            <ShoppingBag className="h-5 w-5" strokeWidth={2.5} />
            ΠΑΡΑΓΓΕΛΙΑ EFOOD
          </a>

          <a
            href={`tel:${TAVERN.phoneTel}`}
            data-testid="hero-phone-btn"
            className="cta-pulse-green group inline-flex items-center justify-center gap-3 rounded-full bg-[color:var(--pk-green)] px-7 py-4 text-sm font-bold uppercase tracking-wide text-white transition-all hover:-translate-y-1 hover:bg-[color:var(--pk-green-dark)] sm:text-base"
          >
            <Phone className="h-5 w-5" strokeWidth={2.5} />
            ΤΗΛΕΦΩΝΙΚΗ ΠΑΡΑΓΓΕΛΙΑ
          </a>
        </div>

        <p
          className="fade-up mt-6 text-sm text-white/70"
          data-testid="hero-phone-text"
          style={{ animationDelay: "0.45s" }}
        >
          ή καλέστε μας απευθείας στο{" "}
          <a
            href={`tel:${TAVERN.phoneTel}`}
            className="font-semibold text-white underline-offset-4 hover:underline"
          >
            {TAVERN.phone}
          </a>
        </p>
      </div>

      {/* Scroll hint */}
      <a
        href="#social-proof"
        aria-label="Κύλιση προς τα κάτω"
        data-testid="hero-scroll-hint"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-white/70 transition-colors hover:text-white"
      >
        <ChevronDown className="h-6 w-6 animate-bounce" />
      </a>
    </section>
  );
}
